import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';

import { Observable, of } from 'rxjs';
import { map, catchError, delay, first } from 'rxjs/operators';

import { AuthenticationService } from 'src/app/_apps/auth/api/authentication.service';

@Injectable({ providedIn: 'root' })
export class EmailTakenValidator implements AsyncValidator
{
    // RFC 2822 compliant regex
    // tslint:disable-next-line: max-line-length
    private emailRegexp = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

    constructor(private authenticationService: AuthenticationService) { }

    validate (control: AbstractControl): Observable<ValidationErrors | null>
    {
        const v = control.value;

        if (!v)
        {
            return of({ required: false });
        }

        if (!control.value.match(this.emailRegexp))
        {
            return of({ email: false });
        }
        return this.authenticationService.isEmailTaken(control.value)
            .pipe(
                delay(500),
                first(),
                map((result) =>
                    result ? { emailTaken: true } : null
                ),
                catchError(() => null)
            );
    }
}

// @Directive({
//     selector: '[productExists][formControlName],[productExists][formControl],[productExists][ngModel]',
//     providers: [
//         {
//             provide: NG_ASYNC_VALIDATORS,
//             useExisting: ExistingProductValidatorDirective,
//             multi: true
//         }
//     ]
// })
// export class EmailTakenValidatorDirective implements AsyncValidator
// {
//     constructor(private authenticationService: AuthenticationService) { }

//     validate (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null>
//     {
//         return existingProductCodeValidator(this.productService)(control);
//     }
// }
